/**
 * Date utility functions
 */

/**
 * Get the first day of the current month at 00:00:00 as a Date object
 *
 * Used for monthly confirmation logic - users need to confirm after each month starts.
 *
 * @returns Date object representing the first day of the current month
 */
export const getFirstDayOfCurrentMonthDate = (): Date => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
};

/**
 * Get the Unix timestamp (milliseconds) of the first day of the current month at 00:00:00
 *
 * Used for monthly confirmation logic - users need to confirm after each month starts.
 *
 * @returns Unix timestamp in milliseconds
 */
export const getFirstDayOfCurrentMonth = (): number => {
  return getFirstDayOfCurrentMonthDate().getTime();
};

/**
 * Get the Unix timestamp (milliseconds) of the first day of the previous month at 00:00:00
 *
 * Used by the checkout payment confirm gate - checkout is blocked only when the
 * customer hasn't confirmed since the previous month started (one month more
 * lenient than the homepage popup, which checks the current month).
 *
 * @returns Unix timestamp in milliseconds
 */
export const getFirstDayOfPreviousMonth = (): number => {
  const now = new Date();
  // Date 建構子會自動處理 month = -1 → 前一年 12 月
  return new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0).getTime();
};
